module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1@2-015f1ea0460cb1b08169248eacb3b5d6.webp";